<template>
  <div>
    <div v-if="dataList.length > 0">
      <div class="m-row">
        <div class="data-line">
          <span class="data-line-text">收费名称</span>
          <span class="data-line-value">{{feeNames}}</span>
        </div>
        <div class="data-line">
          <span class="data-line-text">铺位编号</span>
          <span class="data-line-value">{{dataList[0].bunkCode}}</span>
        </div>
        <div class="data-line">
          <span class="data-line-text">计费区间</span>
          <span class="data-line-value">{{formatDate(dataList[0].startDate)}} 至 {{formatDate(dataList[0].endDate)}}</span>
        </div>
        <div class="data-line">
          <span class="data-line-text">收费金额(元)</span>
          <span class="data-line-value">{{amount}}</span>
        </div>
      </div>
      <div class="bottom">
        <div class="bottom-total">
          <span>总计：￥</span>
          <span style="font-size: 20px;">{{amount}}</span>
        </div>

        <div v-if="!isPressPay" class="feeBtn" @click="getWxUser">缴费</div>
        <div v-if="isPressPay" class="feeBtn disabled">缴费</div>
      </div>
    </div>
    <div v-if="dataList.length == 0 && code != '' && !showLoading && !isLoading">
      <div class="payment-container">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#1AAD19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 60px;height: 60px;">
              <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <h1>已完成支付！</h1>
      </div>
    </div>
    <div v-if="showLoading" class="loading-container">
        <div class="loading-text">正在加载支付结果... <span>{{ countdown }} 秒</span></div>
        <div class="loading-spinner"></div>
    </div>
  </div>
</template>

<script>
  import MD5 from 'js-md5';
  import { Decimal } from "decimal.js"
  import WxPayService from '@/api/wechat/WxPayService.js'
  import Vue from "vue";
  
  export default {
    data() {
      return {
        feeNames: '',
        amount: 0,
        feeNormId: '',
        dataList: [],
        ids: '', // 支付数据ID
        payData: [], //支付数据

        host: 'https://www.jinqiaochina.cn',
        appid: 'wx694c65b6595c1003',
        code: '',
        openid: '',
        isPressPay: false, //是否点击支付

        countdown: 10, //动画加载时间
        countdownTimer: null,
        showLoading: false ,//显示加载动画
        isLoading: true //是否加载
      }
    },
    created() {
      this.ids = this.$route.query.ids;
      const url = window.location.href;
      const parameterName = 'code=';
      const startIndex = url.indexOf(parameterName);
      if(startIndex != -1){
        this.code = url.substring(startIndex+parameterName.length, url.lastIndexOf('&state=1'));
      }
      //获取微信信息
      if(!this.code || typeof(this.code) == 'undefined' || this.code == ''){
        this.wxLogin();
      }else{
        this.getOrderInfo(this.ids);
      }
    },
    methods: {
      wxLogin(){//换取微信code
        let redirect_uri = encodeURIComponent(this.host+'/#/wxPay?ids='+this.ids);//%23
        let scope = 'snsapi_userinfo';
        let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.appid+'&redirect_uri='+redirect_uri+'&response_type=code&scope='+scope+'&state=1&connect_redirect=1#wechat_redirect';
        window.location.href = url
      },
      formatDate(timestamp) {
        let date = new Date(timestamp);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '.' + m + '.' + d;
      },
      getOrderInfo(ids){//获取订单信息和token
        //查询订单是否支付
        //未支付显示后续操作
        //已支付直接提示并关闭页面
        new WxPayService().getOrderInfo(ids).then(({data}) => {
          this.isLoading = false;

          this.dataList = data.list;
          this.feeNormId = data.list[0].feeNormId;
          this.feeNames = [...new Set(this.dataList.map(item => item.feeItemName))].join(',');
          this.amount = data.list.reduce((accumulator, currentValue) => {
            const amount = currentValue.stayAmount || 0;
            return accumulator + amount;
          }, 0);
          this.amount = new Decimal(this.amount).toFixed(2, Decimal.ROUND_HALF_UP)
		  Vue.cookie.set('token', data.token);
        });

      },
      getWxUser() {
        this.isPressPay = true;
        if(!this.openid || typeof(this.openid) == 'undefined' || this.openid == ''){
          new WxPayService().getWxUserInfo({code: this.code, feeNormId: this.feeNormId}).then(({data}) => {
            this.openid = data.openid;
            this.payWithWeChat();
          });
        }else{
          this.payWithWeChat();
        }
      },
      // 点击支付按钮时触发
      payWithWeChat() {
        let _this = this;
        _this.buildPayData();
        _this.$toast.loading({message: '加载中...',forbidClick: true, duration: 0});
        new WxPayService().getWXPay({
            description: this.feeNames,
            amount: (new Decimal(this.amount).mul(100)).toString(),
            openid: this.openid,
            feeNormId: this.feeNormId,
            ids: this.ids
        }).then(({data}) => {
          let orderno = data.orderno;
          let prepay_id = data.prepay_id;
          let timeStamp = data.timeStamp;
          let nonceStr = data.nonce_str;
          let appid = data.appid;
          let sessionKey = data.sessionKey;
          //创建订单
          new WxPayService().createOrder(orderno, _this.feeNormId, JSON.stringify(_this.payData)).then(({data}) => {
			_this.$toast.clear();
            //订单创建成功拉取支付
            let paySign = MD5('appId=' + appid + '&nonceStr=' + nonceStr +
              '&package=prepay_id=' + prepay_id + '&signType=MD5&timeStamp=' +
              timeStamp + '&key='+sessionKey);
            wx.config({
                debug: false,  // 开启调试模式，可以在开发阶段查看日志信息
                appId: appid,    // 公众号的唯一标识
                timestamp: timeStamp,// 生成签名的时间戳
                nonceStr: nonceStr, // 生成签名的随机串
                signature: paySign,// 签名
                jsApiList: ['chooseWXPay'] // 需要使用的JS接口列表
            });
            wx.chooseWXPay({
                timestamp: timeStamp,
                nonceStr: nonceStr,
                package: 'prepay_id=' + prepay_id,
                signType: 'MD5',
                paySign: paySign,
                success: function (res) {
                  // 支付成功后的处理
                  console.log('Payment success:', res);
                  _this.startCountdown(orderno);
                },
                cancel: function (res) {
                    // 用户取消支付后的处理
                    console.log('Payment canceled:', res);
                    _this.isPressPay = false;

                    //删除订单
                    new WxPayService().deleteOrder(orderno);

                },
                fail: function (res) {
                    // 支付失败后的处理
                    console.error('Payment failed:', res);

                    //删除订单
                    new WxPayService().deleteOrder(orderno);

					_this.$toast.fail('支付失败，请重新扫码');
                }
            });
          }).catch((e) => {
			console.log(e);
			_this.$toast.clear();
			_this.$toast.fail('订单创建失败，请重新扫码');
          });
        })
      },
      buildPayData(){
        let receivables = [];
        this.dataList.forEach(d=>{
          receivables.push({
            "receivableId": d.id,
            "amount": d.stayAmount,
            "remarks": ""
          })
        })
        this.payData[0] = {
          tenant: 1,
          projectId: this.dataList[0].projectId,
          projectName: this.dataList[0].projectName,
          customerName: this.dataList[0].customerName,
          customerId: this.dataList[0].customerId,
          houseId: this.dataList[0].houseId,
          houseName: this.dataList[0].houseName,
          feeItemNames: this.feeNames,
          paymentMethods: [{
            "paymentModeId": "1750029458555514882",
            "amount": this.amount,
            "paymentMode": "扫码支付"
          }],
          counterpartyName: this.dataList[0].customerName,
          amount: this.amount,
          exchangeDetails: receivables,
        }
      },
      startCountdown(orderno) {
        this.dataList = [];
        //查询订单状态
        this.queryOrder(orderno);
        //显示加载动画
        this.showLoading = true;
        this.countdownTimer = setInterval(() => {
            this.countdown--;

            if (this.countdown <= 0) {
                clearInterval(this.countdownTimer);
                this.showLoading = false;

                this.closePage();
            }
        }, 1000);
      },
      queryOrder(orderno){
        let _this = this;
        new WxPayService().orderQuery({
            outTradeNo: orderno,
            feeNormId: this.feeNormId
        }).then(({data}) => {
          if(data == 'yes'){
            //阻塞3秒
            setTimeout(function(){
              //关闭加载动画
              clearInterval(this.countdownTimer);
              _this.showLoading = false;
              setTimeout(function(){
                _this.closePage();
              },2000);
            },3000);
          }else{
			_this.$toast.fail('支付失败，请重新扫码');  
          }
        })
      },
      closePage(){
        WeixinJSBridge.call('closeWindow');
      }
    }
  }

</script>

<style scoped>
	.loading-demo {
	  display: flex;
	  justify-content: space-around;
	  align-items: center;
	  height: 100vh;
	}
    .m-row{
		margin-bottom: 20px;
    }
	.data-line {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		padding-left: 10px;
		padding-right: 10px;
		border-bottom: 1px #eeeeee solid;
	}
  .data-line-text {
  	height: 44px;
  	line-height: 44px;
  }

  .data-line-value {
  	height: 88rpx;
  	line-height: 88rpx;
  }

	.bottom {
		position: fixed;
		bottom: 20px;
		left: 0;
		background-color: #fff;
		width: 100%;
		height: 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 10px;
	}
  .bottom-total{
    width: calc(100% - 250px);
  }
  .feeBtn {
  	width: 200px;
  	height: 40px;
    margin: 0 auto;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
    background-color: #0EB55E;
    border-radius: 10px;
  }

  /**
   * 支付结果
   */
  .payment-container {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 100%;
  }

  .success-icon {
    color: #1AAD19;
    margin-bottom: 20px;
  }

  h1 {
    color: #1AAD19;
  }

  /**
   * 加载样式
   */
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
  }

  .loading-text {
      font-size: 24px;
      margin-bottom: 20px;
  }

  .loading-spinner {
      border: 8px solid #1AAD19;
      border-top: 8px solid #f0f0f0; /* 背景色 */
      border-radius: 50%;
      width: 50px;
      height: 50px;
      animation: spin 1s linear infinite;
  }

  @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
  }
</style>
